import get from 'lodash/get';
import { createSelector } from 'reselect';

const baseSelector = (state) => get(state, 'entities', {});

export const userSelector = createSelector(baseSelector, (data) => get(data, 'user', {}));

export const selectPlatformTier = (state) => {
	return state?.entities?.user?.platform_tier ?? {};
};

export const selectBillingFrequencyOptions = (state) => {
	return state?.entities?.user?.billing_frequency_options ?? [];
};

export const selectBillingFrequencyDisclosures = (state) => {
	return state?.entities?.user?.billing_frequency_disclosures ?? [];
};

export const selectBillingSummary = (state) => {
	return state?.entities?.user?.billing_summary ?? null;
};

export const selectBillingSummaryError = (state) => {
	return state?.entities?.user?.billing_summary_error ?? null;
};

export const selectUserPaymentMethods = (state) => {
	return state?.entities?.user?.payment_methods ?? [];
};

export const selectPlans = (state) => {
	return state?.entities?.user?.plans ?? {};
};

export const hasRestrictedReason = (state) => {
	return !!state?.entities?.user?.restricted_reason;
};

export const userAvatarUrlSelector = createSelector(
	baseSelector,
	(entities) => entities?.profile?.avatar_url
);
